"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHoverState = void 0;

var react_1 = require("react");

var useHoverState = function useHoverState(ref) {
  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      hovered = _ref2[0],
      stetHovered = _ref2[1];

  (0, react_1.useEffect)(function () {
    var current = ref.current;

    if (!current) {
      return;
    }

    var onHover = function onHover() {
      stetHovered(true);
    };

    var onLeave = function onLeave() {
      stetHovered(false);
    };

    current.addEventListener('mouseenter', onHover);
    current.addEventListener('mouseleave', onLeave);
    return function () {
      current.removeEventListener('mouseenter', onHover);
      current.removeEventListener('mouseenter', onLeave);
    };
  }, [ref]);
  return hovered;
};

exports.useHoverState = useHoverState;